import React, {useState} from 'react';
import styles from './RoomCard.module.scss'
import {ReactComponent as ChevronOutline} from '../../../../assets/images/svg/ChevroneRightOutlined.svg';
import {ReactComponent as ChevronRight} from '../../../../assets/images/svg/ChevronRight.svg';
import {ReactComponent as ChevronLeft} from '../../../../assets/images/svg/ChevronLeft.svg';

const InCardImageSliderComponent = (props:{images: any[]}) => {
    const [currentImage, setCurrentImage] = useState<number>(0);
    
    // Ensure we have valid images array
    const images = props.images && Array.isArray(props.images) ? props.images : [];
    
    function nextImage() {
        if (images.length === 0) return;
        if (currentImage === images.length - 1) {
            setCurrentImage(0)
            return
        }
        setCurrentImage(old => old + 1)
    }
    function prevImage() {
        if (images.length === 0) return;
        if (currentImage === 0) {
            setCurrentImage(images.length - 1)
            return
        }
        setCurrentImage(old => old - 1)
    }

    // Don't render if no images
    if (images.length === 0) {
        return (
            <div className={`relative ${styles.inCardImage}`} style={{ backgroundImage: 'none', backgroundColor: '#f0f0f0' }}>
                <div className="center-content" style={{ height: '100%', color: '#999' }}>
                    No images available
                </div>
            </div>
        );
    }

    return (
        <div className={`relative ${styles.inCardImage}`} style={{ backgroundImage: `url(${images[currentImage]})` }}>
            {images.length > 1 && (
                <>
                    <div className={`${styles.buttonLeft} center-content`} onClick={prevImage}>
                        <ChevronLeft />
                    </div>
                    <div className={`${styles.buttonRight} center-content`} onClick={nextImage}>
                        <ChevronRight />
                    </div>
                    <div className={`row gap-4 justify-content-center ${styles.dots}`}>
                        {images.map((dot, idx) => (
                            <div
                                key={idx}
                                className={`${idx === currentImage ? styles.dot : styles.inactiveDot} pointer`}
                                onClick={() => setCurrentImage(old => idx)}
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default InCardImageSliderComponent;
export {};
